import React from 'react';
import styled from '@emotion/styled';
import { faExternalLinkAlt } from '@fortawesome/pro-solid-svg-icons';

import Tooltip from '~/App/Components/Tooltip';
import { createFontAwesomeIcon } from '~/App/Components/Attributes/util';

interface LinkProps {
  ctaBgColor: string;
  color: string;
}

const Link = styled.a<LinkProps>`
  &&& {
    font-size: 1em;
    color: ${(props) => props.color};
    background: ${(props) => props.ctaBgColor};
    border: 0.1em solid ${(props) => props.color};
    border-radius: 4em;
    padding: 0.5em;
    line-height: 1.5em;
    white-space: normal;
  }
`;

Link.displayName = 'CallToAction__Link';

interface CallToActionProps {
  ctaUrl: string;
  ctaText: string;
  showCta: boolean;
  ctaBgColor: string;
  color: string;
  onClick: () => void;
}

const CallToAction = ({
  ctaUrl,
  ctaText,
  showCta,
  color,
  ctaBgColor,
  onClick = () => undefined,
}: CallToActionProps) => {
  if (!showCta) {
    return null;
  }

  return (
    <Tooltip
      id='cta-url-tooltip'
      placement='top'
      body={<small>{ctaUrl}</small>}
      opacity={1}
    >
      <Link
        onClick={onClick}
        color={color}
        ctaBgColor={ctaBgColor}
        className={'btn btn-lg'}
      >
        {ctaText}{' '}
        {React.createElement(createFontAwesomeIcon(faExternalLinkAlt))}
      </Link>
    </Tooltip>
  );
};

export default CallToAction;
